import { warmValidatorsForDeepLink } from "@medflyt/webapp-react/src/shared/schema/warm-modal-validators";
import angular from "angular";
import { Chart, registerables } from "chart.js";
import { AppModule } from "./app.module";

Chart.register(...registerables);

// A `?patient=`/`?caregiver=` deep link tells us which modal is about to open, so
// its response validators can be compiled in idle slices now rather than on the
// critical path when the responses land ~1s later. Idle-scheduled, so it yields to
// the AngularJS bootstrap below.
warmValidatorsForDeepLink();

angular.element(() => angular.bootstrap(document, [AppModule], { strictDi: true }));
